var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('div', {
    staticClass: "home"
  }, [_c('Header'), _c('div', {
    staticClass: "usercont content"
  }, [_c('NavMenu'), _c('div', {
    staticClass: "menucont"
  }, [_vm.isHasText ? _c('div', {
    staticClass: "edit"
  }, [_c('div', {
    staticClass: "select"
  }, [_vm.isEdit ? _c('span', [_c('i', {
    class: _vm.isAll ? 'iconfont icongouxuanxuanzhong active' : 'iconfont iconweigouxuan',
    on: {
      "click": _vm.handleAllSelect
    }
  }), _vm._v("全选 ")]) : _vm._e(), _vm.isEdit ? _c('span', {
    on: {
      "click": _vm.cancelChoose
    }
  }, [_vm._v("取消")]) : _vm._e()]), _c('div', {
    staticClass: "delete",
    on: {
      "click": function click($event) {
        _vm.isEdit ? _vm.deleteMessage() : _vm.editMessage();
      }
    }
  }, [_vm._v(_vm._s(_vm.isEdit ? '删除' : '编辑'))])]) : _vm._e(), !_vm.isHasText ? _c('div', {
    staticClass: "nodata"
  }, [_c('img', {
    attrs: {
      "src": require("@/assets/images/no_message.png"),
      "alt": ""
    }
  }), _c('p', [_vm._v("这里还没有新消息")])]) : _vm._e(), _c('el-tabs', {
    class: {
      'visibletab': _vm.isEdit
    },
    on: {
      "tab-click": _vm.handleClick
    },
    model: {
      value: _vm.messageType,
      callback: function callback($$v) {
        _vm.messageType = $$v;
      },
      expression: "messageType"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "name": "1"
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_vm._v(" 发货通知 "), this.notifysState.notifysList.sendGoodsMsgNum !== 0 ? _c('em', [_vm._v("（" + _vm._s(this.notifysState.notifysList.sendGoodsMsgNum) + "）")]) : _vm._e()]), _c('ul', {
    staticClass: "message-list"
  }, _vm._l(_vm.messageList, function (item, index) {
    return _c('li', {
      key: index,
      on: {
        "click": function click($event) {
          return _vm.goDetails(item.serverId, item.id, 0);
        }
      }
    }, [_vm.isEdit ? _c('i', {
      class: item.checked ? 'iconfont icongouxuanxuanzhong active' : 'iconfont iconweigouxuan',
      on: {
        "click": function click($event) {
          $event.stopPropagation();
          return _vm.handleSelect(index);
        }
      }
    }) : _vm._e(), _c('div', [_c('h6', {
      class: {
        'unread': item.isRead === 0
      }
    }, [_c('span', [_vm._v(_vm._s(item.title))]), _c('em', [_vm._v(_vm._s(_vm._f("dateTime")(item.createTime)))])]), _c('p', [_vm._v(_vm._s(item.content))])])]);
  }), 0)])], 1), _vm.totalnumber > 10 ? _c('div', {
    staticClass: "pagination-container"
  }, [_c('el-pagination', {
    attrs: {
      "current-page": _vm.currentpage,
      "page-sizes": [10, 20, 50],
      "page-size": 10,
      "total": _vm.totalnumber,
      "layout": "total, sizes, prev, pager, next, jumper"
    },
    on: {
      "update:currentPage": function updateCurrentPage($event) {
        _vm.currentpage = $event;
      },
      "update:current-page": function updateCurrentPage($event) {
        _vm.currentpage = $event;
      },
      "size-change": function sizeChange($event) {
        return _vm.handleSizeChange($event);
      },
      "current-change": function currentChange($event) {
        return _vm.handleCurrentChange($event);
      }
    }
  })], 1) : _vm._e()], 1)], 1), _c('Footer')], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };